import Select from 'react-select';
import countries from 'i18n-iso-countries';
import 'i18n-iso-countries/langs/pl.json';
import flags from 'emoji-flags';
import {useTranslation} from "react-i18next";

countries.registerLocale(require('i18n-iso-countries/langs/pl.json'));

const SelectCountry = ({value, onChange}) => {
    const {t} = useTranslation('default');
    const allCountries = countries.getNames('pl', {select: 'official'});

    const options = [
        {
            label: '🇵🇱 Polska',
            value: 'PL'
        },
        {
            label: '──────────',
            isDisabled: true
        },
        ...Object.entries(allCountries)
            .filter(([code]) => code !== 'PL')
            .map(([code, name]) => ({
                label: `${flags.countryCode(code)?.emoji || ''} ${name}`.trim(),
                value: code
            }))
    ];

    return (
        <Select
            options={options}
            value={options.find(opt => opt.value === value) || null}
            onChange={(option) => {
                console.log('Country selected:', option);
                onChange(option?.value);
            }}
            isSearchable
            placeholder={t('setup.form.country.placeholder')}
            styles={{
                control: (base, state) => ({
                    ...base,
                    minHeight: '40px',
                    borderColor: state.isFocused ? '#089A7A' : '#909090',
                    boxShadow: state.isFocused ? '0 0 0 1px #089A7A' : 'none',
                    '&:hover': {
                        borderColor: '#089A7A'
                    }
                }),
                option: (base, { isFocused }) => ({
                    ...base,
                    backgroundColor: isFocused ? '#089A7A' : 'white',
                    color: isFocused ? 'white' : 'black'
                })
            }}
        />
    );
};

export default SelectCountry;
